module.exports = __webpack_public_path__ + "static/media/poroDodge.9576b74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/poroDodge.png
// module id = 84
// module chunks = 0